var _defs, _rect, _g, _g2, _path, _path2, _circle, _path3, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 333,
    height: 233,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "gutter-cleaning-1",
    className: "cls-1",
    width: 333,
    height: 233,
    rx: 10,
    transform: "translate(868 264)"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#022752}.cls-3,.cls-7{fill:#073265}.cls-5,.cls-6{fill:none}.cls-5,.cls-6,.cls-7{stroke-miterlimit:10}.cls-6,.cls-7{stroke-width:2.301px}.cls-6{stroke:#063165}.cls-7{stroke:#022752}.cls-8,.cls-9{stroke:none}.cls-9{fill:#073265}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(-868 -264)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "gutter-cleaning-1-2",
    "data-name": "gutter-cleaning-1",
    className: "cls-1",
    width: 333,
    height: 233,
    rx: 10,
    transform: "translate(868 264)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(-17.651 -2.423)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(957.948 316.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-3",
    d: "M715.153 1497.483v-12.749a3.188 3.188 0 0 1 3.188-3.188h28.686a3.188 3.188 0 0 1 3.188 3.188v12.749z",
    transform: "translate(-709.575 -1481.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-3",
    d: "M749.391 1502.327a3.188 3.188 0 0 0 3.043-2.236l3.16-10.112a2.749 2.749 0 0 0 .125-.82v-.018a2.75 2.75 0 0 0-5.379-.809l-2.59 8.419h-30.281l-2.59-8.419a2.75 2.75 0 0 0-5.379.809v.018a2.753 2.753 0 0 0 .125.82l3.16 10.112a3.187 3.187 0 0 0 3.043 2.236z",
    transform: "translate(-709.501 -1481.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-3",
    d: "M719.965 1492.85h10.36a2.391 2.391 0 0 1 2.39 2.39v1.594h-15.14v-1.594a2.39 2.39 0 0 1 2.39-2.39z",
    transform: "translate(-709.607 -1481.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-3",
    d: "M735.306 1492.85h10.359a2.391 2.391 0 0 1 2.391 2.39v1.594h-15.14v-1.594a2.39 2.39 0 0 1 2.39-2.39z",
    transform: "translate(-709.807 -1481.694)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(11.156 4.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-3",
    d: "M720.8 1486.39h1.6v1.594h-1.6z",
    transform: "translate(-720.805 -1486.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-3",
    d: "M726.457 1486.39h1.593v1.594h-1.593z",
    transform: "translate(-720.879 -1486.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-3",
    d: "M732.109 1486.39h1.591v1.594h-1.593z",
    transform: "translate(-720.953 -1486.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-3",
    d: "M737.76 1486.39h1.594v1.594h-1.594z",
    transform: "translate(-721.027 -1486.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-3",
    d: "M743.412 1486.39h1.594v1.594h-1.594z",
    transform: "translate(-721.101 -1486.39)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-3",
    d: "m716.757 1502.538-.8 4.782h1.594l3.188-4.782z",
    transform: "translate(-709.586 -1481.82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-3",
    d: "m749.011 1502.538.8 4.782h-1.593l-3.188-4.782z",
    transform: "translate(-709.965 -1481.82)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(957.948 428.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    className: "cls-3",
    d: "M0 0h41.313v3.248H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-3",
    d: "M985.709 1494.07h-21.393l-3.992-6.5H989.7z",
    transform: "translate(-954.356 -1484.327)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(6.862 12.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-3",
    d: "M961.354 1502.39a.532.532 0 0 1 0-.758l.758-.758a.534.534 0 0 1 .758 0 17.843 17.843 0 0 0 24.516 0 .534.534 0 0 1 .758 0l.758.758a.535.535 0 0 1 0 .758 20.145 20.145 0 0 1-18.672 4.9 19.77 19.77 0 0 1-8.876-4.9zm4.3-4.3a.534.534 0 0 1 0-.757l.758-.759a.521.521 0 0 1 .38-.158.463.463 0 0 1 .347.126 11.468 11.468 0 0 0 5.118 2.749 12.063 12.063 0 0 0 5.75 0 11.468 11.468 0 0 0 5.118-2.749.469.469 0 0 1 .347-.126.517.517 0 0 1 .38.158l.759.759a.535.535 0 0 1 0 .757 13.491 13.491 0 0 1-6.051 3.271 14.329 14.329 0 0 1-6.84.015 13.4 13.4 0 0 1-6.069-3.283z",
    transform: "translate(-961.196 -1496.419)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    className: "cls-3",
    transform: "translate(18.275 5.966)",
    d: "M0 0h4.764v1.059H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(1184.484 285.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "m1467.43 1486.722-11.129-5.716-11.13 5.716",
    transform: "translate(-1438.676 -1481.006)",
    style: {
      strokeWidth: "2.301px",
      strokeMiterlimit: 10,
      stroke: "#073265",
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    className: "cls-3",
    transform: "translate(0 4.502)",
    d: "M0 0h35.25v20.648H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    className: "cls-3",
    transform: "translate(2.572 6.528)",
    d: "M0 0h30.105v16.595H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    className: "cls-3",
    cx: 3.722,
    cy: 3.722,
    r: 3.722,
    transform: "translate(5.576 8.757)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-3",
    d: "m1456.1 1505.612 11.3-11.3 5.177 5.177v6.12z",
    transform: "translate(-1439.892 -1482.488)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(891.254 283.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(.28 1.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-3",
    d: "M1691.515 1502.658a1.532 1.532 0 0 0-2.179 0l-.559.551a1.557 1.557 0 0 0 0 2.187l.307.307a1.548 1.548 0 0 0 2.18 0l.559-.558a1.56 1.56 0 0 0 0-2.188z",
    transform: "translate(-1685.45 -1481.401)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-3",
    d: "m1712.136 1483.378-.362-.339a6.762 6.762 0 0 1-.338-.362c-.37-.409-.692-.756-1.157-.756a1.2 1.2 0 0 0-.841.417l-1.723 1.723a.785.785 0 0 0 .008 1.117l-10.377 10.377-1.7 1.7 1.912 1.912 1.7-1.7 10.377-10.384a.8.8 0 0 0 .558.244.817.817 0 0 0 .559-.236l1.715-1.715a1.192 1.192 0 0 0 .425-.866c-.009-.456-.355-.77-.756-1.132z",
    transform: "translate(-1685.262 -1481.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-3",
    d: "M1695.01 1496.657a1.944 1.944 0 0 0-1.369.566l-.944.944c-.094-.007-.182-.016-.276-.016a1.92 1.92 0 0 0-1.368.559l-4.964 4.972a1.928 1.928 0 0 0 0 2.729l2.2 2.2a1.927 1.927 0 0 0 2.73 0l4.963-4.972a1.91 1.91 0 0 0 .567-1.361 1.586 1.586 0 0 0-.023-.275l.952-.953a1.91 1.91 0 0 0 .566-1.36 1.944 1.944 0 0 0-.22-.9l-1.912-1.912a1.96 1.96 0 0 0-.902-.221z",
    transform: "translate(-1685.522 -1481.543)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-3",
    d: "M1695.906 1496.876a1.94 1.94 0 0 0-2.266.347l-.944.944c-.094-.007-.182-.016-.276-.016a1.92 1.92 0 0 0-1.368.559l-4.964 4.972a1.928 1.928 0 0 0 0 2.729l1.094 1.094 1.818-1.818 2.738-2.738 5.121-5.122z",
    transform: "translate(-1685.242 -1479.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-3",
    d: "M1713.379 1500.264a5.744 5.744 0 0 0-6.4-1.188 2.07 2.07 0 0 0-.3-.362l-4.177-4.186-6.246-6.245a5.768 5.768 0 0 0 .472-2.289 5.734 5.734 0 0 0-7.254-5.539.594.594 0 0 0-.409.409.584.584 0 0 0 .165.558c.024.017 2.062 2.069 2.739 2.754a.493.493 0 0 1 .086.369l-.008.04a10.81 10.81 0 0 1-.354 2.116 10.328 10.328 0 0 1-2.156.362h-.031a.065.065 0 0 1-.04.007.516.516 0 0 1-.369-.157c-.708-.708-2.667-2.651-2.682-2.667a.587.587 0 0 0-.433-.2.573.573 0 0 0-.536.441 5.733 5.733 0 0 0 5.539 7.245 5.653 5.653 0 0 0 2.289-.473l4.335 4.335 1.912 1.911 4.178 4.186a2.718 2.718 0 0 0 .369.291 5.747 5.747 0 0 0 5.247 8.079 5.484 5.484 0 0 0 1.518-.205.586.586 0 0 0 .4-.4.563.563 0 0 0-.165-.558c-.024-.024-2.061-2.077-2.738-2.754a.464.464 0 0 1-.079-.369v-.04a10.849 10.849 0 0 1 .355-2.124 10.665 10.665 0 0 1 2.155-.354h.016l.024-.007h.039a.483.483 0 0 1 .362.157c.708.7 2.667 2.651 2.682 2.667a.611.611 0 0 0 .433.189.582.582 0 0 0 .543-.44 5.746 5.746 0 0 0-1.481-5.559z",
    transform: "translate(-1685.249 -1480.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-3",
    d: "M1687.1 1504.825a.493.493 0 0 1 0-.708l4.312-4.312a.5.5 0 1 1 .708.708l-4.312 4.312a.5.5 0 0 1-.708 0z",
    transform: "translate(-1685.205 -1479.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-3",
    d: "M1688.4 1506.116a.494.494 0 0 1 0-.709l4.312-4.311a.5.5 0 0 1 .709.708l-4.312 4.312a.5.5 0 0 1-.709 0z",
    transform: "translate(-1685.172 -1479.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-3",
    d: "M1689.687 1507.407a.494.494 0 0 1 0-.709l4.312-4.312a.5.5 0 0 1 .709.709l-4.312 4.312a.5.5 0 0 1-.709 0z",
    transform: "translate(-1685.138 -1479.685)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "rotate(180 534.706 156.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    className: "cls-3",
    d: "M8.018 0H1.153L0 7.442h9.171z",
    transform: "translate(9.598)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(1.549 9.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    className: "cls-3",
    transform: "rotate(-70.177 1.172 .824)",
    d: "M0 0h1.751v3.524H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(0 17.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    className: "cls-3",
    transform: "rotate(-7.305 4.527 .289)",
    d: "M0 0h4.547v1.751H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(2.173 24.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    className: "cls-3",
    transform: "rotate(-24.743 4.217 .925)",
    d: "M0 0h4.421v1.751H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(22.909 9.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    className: "cls-3",
    transform: "rotate(-19.823 3.42 .598)",
    d: "M0 0h3.524v1.751H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(23.634 17.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    className: "cls-3",
    transform: "rotate(-82.695 .987 .869)",
    d: "M0 0h1.751v4.547H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(21.446 24.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    className: "cls-3",
    transform: "rotate(-65.257 1.242 .795)",
    d: "M0 0h1.751v4.421H0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    className: "cls-3",
    d: "M12.214 1.444A6.725 6.725 0 0 0 8.591.047a6.317 6.317 0 0 0-.244-.022h-.059Q8.162.013 8.034.008h-.08C7.851 0 7.747 0 7.641 0h-.024C7.51 0 7.4 0 7.3.005h-.088c-.08 0-.159.007-.237.012L6.9.026c-.1.008-.207.017-.309.027a6.7 6.7 0 0 0-3.543 1.39C.964 3.108 0 6.113 0 9.944c0 5.977 4.253 13.9 7.617 13.9h.024c3.364 0 7.617-7.923 7.617-13.9 0-3.831-.964-6.836-3.044-8.5z",
    transform: "translate(6.555 5.998)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    className: "cls-3",
    d: "M0 0v23.844c3.364 0 7.617-7.923 7.617-13.9 0-3.831-.964-6.836-3.043-8.5A7.1 7.1 0 0 0 0 0z",
    transform: "translate(14.195 5.998)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    className: "cls-3",
    d: "M2 .046V10.5H0V.054A9.68 9.68 0 0 1 1.031 0h.024A9.369 9.369 0 0 1 2 .046z",
    transform: "translate(13.141 5.998)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    transform: "translate(959.27 260.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(13.756 19.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    className: "cls-3",
    d: "M1431.185 724.531h-8.064l-4.432-3.459h16.93z",
    transform: "translate(-1418.689 -721.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    className: "cls-3",
    transform: "translate(4.433 3.459)",
    d: "M0 0h8.064v7.273H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0 8.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(1.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-3",
    d: "M1418.771 711.164h-11.531a10.909 10.909 0 0 0 16.675 9.262 10.9 10.9 0 0 1-5.144-9.262z",
    transform: "translate(-1407.241 -711.164)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "cls-3",
    d: "M1443.757 711.165a12.06 12.06 0 0 1-12.061 12.06h-14.546a12.059 12.059 0 0 0 12.056-12.06z",
    transform: "translate(-1405.088 -711.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-3",
    d: "M1430.317 711.164h-1.151a10.91 10.91 0 1 1-21.819 0h-1.147a12.06 12.06 0 0 0 12.06 12.061 12.061 12.061 0 0 0 12.057-12.061z",
    transform: "translate(-1406.196 -711.164)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1416.233 703.075h-.456a2.094 2.094 0 0 1-2.094 2.094v.456a2.094 2.094 0 0 1 2.094 2.094h.456a2.1 2.1 0 0 1 2.094-2.094v-.456a2.1 2.1 0 0 1-2.094-2.094z",
    transform: "translate(-1405.439 -703.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1415.777 703.075h.456c0 1.156.938 2.094 2.094 2.094v.456a2.095 2.095 0 0 0-2.094 2.095h-.456a2.094 2.094 0 0 0-2.094-2.095v-.456a2.094 2.094 0 0 0 2.094-2.094z",
    transform: "translate(-1405.439 -703.075)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1423.322 705.184h-.969a4.452 4.452 0 0 1-4.452 4.452v.969a4.451 4.451 0 0 1 4.452 4.451h.969a4.451 4.451 0 0 1 4.451-4.451v-.969a4.452 4.452 0 0 1-4.451-4.452z",
    transform: "translate(-1405.012 -702.862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1422.837 709.067a6.336 6.336 0 0 1-1.053 1.053c.39.309.745.662 1.053 1.053a6.335 6.335 0 0 1 1.054-1.053 6.336 6.336 0 0 1-1.054-1.053m-.484-3.883h.969a4.452 4.452 0 0 0 4.45 4.452v.969a4.451 4.451 0 0 0-4.45 4.45h-.97a4.451 4.451 0 0 0-4.451-4.45v-.97a4.452 4.452 0 0 0 4.452-4.451z",
    transform: "translate(-1405.012 -702.862)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(880.177 451.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32-2",
    "data-name": "Group 32",
    transform: "translate(13.756 19.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64-2",
    "data-name": "Path 64",
    className: "cls-3",
    d: "M1431.185 724.531h-8.064l-4.432-3.459h16.93z",
    transform: "translate(-1418.689 -721.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_42-2",
    "data-name": "Rectangle 42",
    className: "cls-3",
    transform: "translate(4.433 3.459)",
    d: "M0 0h8.064v7.273H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35-2",
    "data-name": "Group 35",
    transform: "translate(0 8.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33-2",
    "data-name": "Group 33",
    transform: "translate(1.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65-2",
    "data-name": "Path 65",
    className: "cls-3",
    d: "M1418.771 711.164h-11.531a10.909 10.909 0 0 0 16.675 9.262 10.9 10.9 0 0 1-5.144-9.262z",
    transform: "translate(-1407.241 -711.164)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34-2",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66-2",
    "data-name": "Path 66",
    className: "cls-3",
    d: "M1443.757 711.165a12.06 12.06 0 0 1-12.061 12.06h-14.546a12.059 12.059 0 0 0 12.056-12.06z",
    transform: "translate(-1405.088 -711.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67-2",
    "data-name": "Path 67",
    className: "cls-3",
    d: "M1430.317 711.164h-1.151a10.91 10.91 0 1 1-21.819 0h-1.147a12.06 12.06 0 0 0 12.06 12.061 12.061 12.061 0 0 0 12.057-12.061z",
    transform: "translate(-1406.196 -711.164)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_68-2",
    "data-name": "Path 68",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1416.233 703.075h-.456a2.094 2.094 0 0 1-2.094 2.094v.456a2.094 2.094 0 0 1 2.094 2.094h.456a2.1 2.1 0 0 1 2.094-2.094v-.456a2.1 2.1 0 0 1-2.094-2.094z",
    transform: "translate(-1405.439 -703.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1415.777 703.075h.456c0 1.156.938 2.094 2.094 2.094v.456a2.095 2.095 0 0 0-2.094 2.095h-.456a2.094 2.094 0 0 0-2.094-2.095v-.456a2.094 2.094 0 0 0 2.094-2.094z",
    transform: "translate(-1405.439 -703.075)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_69-2",
    "data-name": "Path 69",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1423.322 705.184h-.969a4.452 4.452 0 0 1-4.452 4.452v.969a4.451 4.451 0 0 1 4.452 4.451h.969a4.451 4.451 0 0 1 4.451-4.451v-.969a4.452 4.452 0 0 1-4.451-4.452z",
    transform: "translate(-1405.012 -702.862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1422.837 709.067a6.336 6.336 0 0 1-1.053 1.053c.39.309.745.662 1.053 1.053a6.335 6.335 0 0 1 1.054-1.053 6.336 6.336 0 0 1-1.054-1.053m-.484-3.883h.969a4.452 4.452 0 0 0 4.45 4.452v.969a4.451 4.451 0 0 0-4.45 4.45h-.97a4.451 4.451 0 0 0-4.451-4.45v-.97a4.452 4.452 0 0 0 4.452-4.451z",
    transform: "translate(-1405.012 -702.862)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(887.175 336.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    className: "cls-3",
    transform: "rotate(24.971 -10.34 21.342)",
    d: "M0 0h15.928v15.928H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    className: "cls-3",
    transform: "rotate(24.971 -19.902 28.542)",
    d: "M0 0h8.06v1.997H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    className: "cls-3",
    transform: "rotate(24.971 8.351 37.716)",
    d: "M0 0h10.762v9.421H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    className: "cls-3",
    transform: "rotate(24.971 1.17 41.976)",
    d: "M0 0h5.823v1.443H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-6",
    d: "M1235.9 1483.649a9.371 9.371 0 0 0-12.451 4.539l-8.817 18.932-17.861-8.319",
    transform: "translate(-1196.771 -1478.617)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    className: "cls-7",
    cx: 2.909,
    cy: 2.909,
    r: 2.909,
    transform: "translate(14.291 28.495)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(1109.11 261.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13-2",
    "data-name": "Rectangle 13",
    className: "cls-3",
    transform: "rotate(24.971 -10.34 21.342)",
    d: "M0 0h15.928v15.928H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14-2",
    "data-name": "Rectangle 14",
    className: "cls-3",
    transform: "rotate(24.971 -19.902 28.542)",
    d: "M0 0h8.06v1.997H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15-2",
    "data-name": "Rectangle 15",
    className: "cls-3",
    transform: "rotate(24.971 8.351 37.716)",
    d: "M0 0h10.762v9.421H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16-2",
    "data-name": "Rectangle 16",
    className: "cls-3",
    transform: "rotate(24.971 1.17 41.976)",
    d: "M0 0h5.823v1.443H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22-2",
    "data-name": "Path 22",
    className: "cls-6",
    d: "M1235.9 1483.649a9.371 9.371 0 0 0-12.451 4.539l-8.817 18.932-17.861-8.319",
    transform: "translate(-1196.771 -1478.617)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6-2",
    "data-name": "Ellipse 6",
    className: "cls-7",
    cx: 2.909,
    cy: 2.909,
    r: 2.909,
    transform: "translate(14.291 28.495)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(884.546 398.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    className: "cls-3",
    transform: "translate(13.408 18.146)",
    d: "M0 0h12.377v6.861H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    className: "cls-3",
    transform: "translate(0 18.146)",
    d: "M0 0h5.191v6.861H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    className: "cls-3",
    transform: "translate(0 3.579)",
    d: "M0 0h5.191v6.861H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    className: "cls-3",
    transform: "translate(34.002 18.146)",
    d: "M0 0h5.191v6.861H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    className: "cls-3",
    transform: "translate(34.002 3.579)",
    d: "M0 0h5.191v6.861H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    className: "cls-3",
    transform: "translate(37.518 3.579)",
    d: "M0 0h1.674v21.427H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    className: "cls-3",
    transform: "translate(0 3.579)",
    d: "M0 0h1.674v21.427H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(7.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    className: "cls-3",
    d: "M1874.87 1810.939v13.167h-5.62v2.253h5.62v13.166h3.827v-28.585zm2.346 27.188h-.865v-3.916h.865zm0-5.469h-.865v-3.916h.865zm0-5.469h-.865v-3.916h.865zm0-5.469h-.865v-3.916h.865zm0-5.469h-.865v-3.916h.865z",
    transform: "translate(-1854.835 -1810.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    className: "cls-3",
    d: "M1753.654 1810.939h-3.828v28.585h3.828v-13.166h5.62v-2.253h-5.62zm-1.553 27.188h-.865v-3.916h.865zm0-5.469h-.865v-3.916h.865zm0-5.469h-.865v-3.916h.865zm0-5.469h-.865v-3.916h.865zm0-5.469h-.865v-3.916h.865z",
    transform: "translate(-1749.826 -1810.939)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    className: "cls-3",
    transform: "translate(13.408 3.579)",
    d: "M0 0h12.377v6.861H0z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(962.073 474.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    className: "cls-3",
    transform: "translate(15.039)",
    d: "M0 0h2.194v3.328H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    className: "cls-3",
    transform: "translate(11.444 3.328)",
    d: "M0 0h9.414v5.054H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(0 3.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    className: "cls-3",
    transform: "translate(11.444)",
    d: "M0 0h4.707v5.054H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(5.965 25.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(9.103 2.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    className: "cls-3",
    d: "M0 0h2.165v5.545H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    className: "cls-3",
    transform: "rotate(-50.002 4.555 2.124)",
    d: "M0 0h5.545v2.165H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(15.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    className: "cls-3",
    transform: "rotate(-40 1.912 .696)",
    d: "M0 0h2.165v5.545H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    className: "cls-3",
    d: "M1813.259 2296.209h-16.3l-8 13.3h32.3z",
    transform: "translate(-1788.956 -2290.441)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    className: "cls-3",
    d: "M1788.956 2309.511h16.151v-13.3h-8.153z",
    transform: "translate(-1788.956 -2287.113)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(11.276 23.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    className: "cls-3",
    d: "M1945.18 2501.279a4.9 4.9 0 0 0 .186.878 4.9 4.9 0 0 1-.186-.878z",
    transform: "translate(-1945.18 -2501.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    className: "cls-3",
    d: "M2012.725 2505.607a4.91 4.91 0 0 0 4.875-4.328h-4.875z",
    transform: "translate(-2007.85 -2501.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    className: "cls-3",
    d: "M1945.18 2501.279a4.9 4.9 0 0 0 .186.878q.036.115.077.229a4.913 4.913 0 0 0 4.613 3.222v-4.328z",
    transform: "translate(-1945.18 -2501.279)"
  }))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "rotate(-90 680.492 -281.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "rotate(90 12.868 12.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    className: "cls-3",
    transform: "translate(0 13.296)",
    d: "M0 0h25.886v4.976H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    className: "cls-3",
    transform: "translate(6.133 20.76)",
    d: "M0 0h19.753v4.976H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    className: "cls-3",
    transform: "translate(28.13 13.296)",
    d: "M0 0h1.18v12.44H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    className: "cls-3",
    transform: "translate(31.749 13.296)",
    d: "M0 0h1.18v12.44H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    className: "cls-3",
    transform: "translate(35.368 13.296)",
    d: "M0 0h1.18v12.44H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    className: "cls-3",
    d: "M0 0h25.886v11.319H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    className: "cls-3",
    d: "M25.886 0 0 11.319h25.886z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(28.13 10.139)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    className: "cls-3",
    cx: 0.59,
    cy: 0.59,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    className: "cls-3",
    cx: 0.59,
    cy: 0.59,
    r: 0.59,
    transform: "translate(3.619)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    className: "cls-3",
    cx: 0.59,
    cy: 0.59,
    r: 0.59,
    transform: "translate(7.239)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(28.13 6.759)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    className: "cls-3",
    cx: 0.59,
    cy: 0.59,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    className: "cls-3",
    cx: 0.59,
    cy: 0.59,
    r: 0.59,
    transform: "translate(3.619)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    className: "cls-3",
    cx: 0.59,
    cy: 0.59,
    r: 0.59,
    transform: "translate(7.239)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(28.13 3.38)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    className: "cls-3",
    cx: 0.59,
    cy: 0.59,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    className: "cls-3",
    cx: 0.59,
    cy: 0.59,
    r: 0.59,
    transform: "translate(3.619)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    className: "cls-3",
    cx: 0.59,
    cy: 0.59,
    r: 0.59,
    transform: "translate(7.239)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(28.13)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    className: "cls-3",
    cx: 0.59,
    cy: 0.59,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    className: "cls-3",
    cx: 0.59,
    cy: 0.59,
    r: 0.59,
    transform: "translate(3.619)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    className: "cls-3",
    cx: 0.59,
    cy: 0.59,
    r: 0.59,
    transform: "translate(7.239)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    className: "cls-3",
    transform: "translate(0 20.76)",
    d: "M0 0h.896v4.976H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    className: "cls-3",
    transform: "translate(1.736 20.76)",
    d: "M0 0h.896v4.976H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    className: "cls-3",
    transform: "translate(3.472 20.76)",
    d: "M0 0h.896v4.976H0z"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(-120.744 21.256)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    className: "cls-3",
    cx: 109,
    cy: 109,
    r: 109,
    transform: "translate(1111.744 280.744)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(1165.723 334.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11-2",
    "data-name": "Group 11",
    transform: "translate(1.037 6.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25-2",
    "data-name": "Path 25",
    className: "cls-1",
    d: "M1700.112 1503.885a5.667 5.667 0 0 0-8.057 0l-2.067 2.037a5.757 5.757 0 0 0 0 8.088l1.134 1.134a5.726 5.726 0 0 0 8.061 0l2.067-2.063a5.77 5.77 0 0 0 0-8.092z",
    transform: "translate(-1677.682 -1425.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26-2",
    "data-name": "Path 26",
    className: "cls-1",
    d: "M1756.631 1487.308c-.437-.41-.877-.816-1.339-1.252-.467-.466-.872-.9-1.252-1.338-1.37-1.514-2.561-2.8-4.279-2.8a4.423 4.423 0 0 0-3.11 1.544l-6.373 6.373a2.9 2.9 0 0 0 .031 4.13l-38.377 38.377-6.285 6.281 7.07 7.071 6.285-6.285 38.377-38.4a2.972 2.972 0 0 0 2.063.9 3.02 3.02 0 0 0 2.067-.872l6.343-6.343a4.405 4.405 0 0 0 1.57-3.2c-.03-1.685-1.308-2.85-2.791-4.186z",
    transform: "translate(-1657.243 -1481.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27-2",
    "data-name": "Path 27",
    className: "cls-1",
    d: "M1720.61 1496.657a7.184 7.184 0 0 0-5.064 2.094l-3.49 3.49c-.348-.027-.671-.057-1.02-.057a7.1 7.1 0 0 0-5.061 2.068l-18.359 18.386a7.129 7.129 0 0 0 0 10.094l8.117 8.118a7.127 7.127 0 0 0 10.1 0l18.355-18.387a7.063 7.063 0 0 0 2.1-5.033 5.811 5.811 0 0 0-.087-1.017l3.521-3.524a7.065 7.065 0 0 0 2.094-5.031 7.186 7.186 0 0 0-.815-3.319l-7.071-7.071a7.253 7.253 0 0 0-3.32-.811z",
    transform: "translate(-1685.522 -1440.763)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_28-2",
    "data-name": "Path 28",
    className: "cls-1",
    d: "M1723.925 1497.469a7.173 7.173 0 0 0-8.379 1.283l-3.49 3.49c-.348-.027-.671-.057-1.02-.057a7.1 7.1 0 0 0-5.061 2.068l-18.359 18.386a7.129 7.129 0 0 0 0 10.094l4.044 4.047 6.721-6.721 10.125-10.125 18.94-18.944z",
    transform: "translate(-1684.485 -1434.421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29-2",
    "data-name": "Path 29",
    className: "cls-1",
    d: "M1789.281 1554.268a21.244 21.244 0 0 0-23.655-4.393 7.674 7.674 0 0 0-1.108-1.339l-15.446-15.481-23.1-23.1a21.325 21.325 0 0 0 1.745-8.467 21.259 21.259 0 0 0-21.238-21.242 21.3 21.3 0 0 0-5.588.758 2.2 2.2 0 0 0-1.513 1.514 2.158 2.158 0 0 0 .61 2.063c.087.061 7.625 7.651 10.128 10.185a1.828 1.828 0 0 1 .319 1.365l-.031.148a39.982 39.982 0 0 1-1.308 7.826c-.929.466-4.772 1.047-7.974 1.339h-.114a.238.238 0 0 1-.148.027 1.907 1.907 0 0 1-1.366-.581c-2.618-2.618-9.862-9.806-9.919-9.863a2.168 2.168 0 0 0-1.6-.729 2.12 2.12 0 0 0-1.98 1.632 21.2 21.2 0 0 0 20.484 26.8 20.9 20.9 0 0 0 8.466-1.749l16.031 16.034 7.071 7.067 15.45 15.481a10.012 10.012 0 0 0 1.366 1.077 21.253 21.253 0 0 0 19.406 29.879 20.282 20.282 0 0 0 5.615-.758 2.17 2.17 0 0 0 1.483-1.483 2.082 2.082 0 0 0-.611-2.063c-.087-.087-7.621-7.681-10.125-10.185a1.712 1.712 0 0 1-.292-1.365v-.148a40.125 40.125 0 0 1 1.312-7.856 39.421 39.421 0 0 1 7.97-1.308h.06l.087-.027h.144a1.789 1.789 0 0 1 1.339.581 7842.53 7842.53 0 0 1 9.919 9.862 2.259 2.259 0 0 0 1.6.7 2.151 2.151 0 0 0 2.007-1.627 21.25 21.25 0 0 0-5.496-20.574z",
    transform: "translate(-1685.249 -1480.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-2",
    "data-name": "Path 31",
    className: "cls-1",
    d: "M1687.509 1518.756a1.823 1.823 0 0 1 0-2.617l15.948-15.947a1.852 1.852 0 0 1 2.621 2.617l-15.947 15.947a1.838 1.838 0 0 1-2.622 0z",
    transform: "translate(-1680.483 -1426.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-2",
    "data-name": "Path 32",
    className: "cls-1",
    d: "M1688.8 1520.047a1.828 1.828 0 0 1 0-2.621l15.947-15.943a1.852 1.852 0 0 1 2.621 2.617l-15.947 15.947a1.839 1.839 0 0 1-2.621 0z",
    transform: "translate(-1676.876 -1422.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-2",
    "data-name": "Path 33",
    className: "cls-1",
    d: "M1690.091 1521.341a1.828 1.828 0 0 1 0-2.621l15.947-15.947a1.853 1.853 0 0 1 2.621 2.621l-15.947 15.947a1.839 1.839 0 0 1-2.621 0z",
    transform: "translate(-1673.27 -1418.816)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImg);
export default __webpack_public_path__ + "static/media/default-img.a4b4e7d5cbc8da5195f723fed92b12be.svg";
export { ForwardRef as ReactComponent };